export const SIZES = {
  DISPLAY_NAME: 22,
  SYSTEM_NAME: 20,
  DATA_TYPE: 10,
  VARIABLE_TYPE: 10,
  UPDATED: 18,
  DESCRIPTION: 20,
};
